import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import Alert from "react-s-alert";
import Paging from '../../components/Paging'
import { FOTO_PRESENSI_HOST } from "../../constants/siteConfig";
import qs from 'qs'
import axios from '../../axios'
import { PER_PAGE_VIEW } from '../../constants/general'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import XLSX from 'xlsx'

// const yourDate = new Date()
const NewDateStart = moment().format('YYYY-MM-DD')
const NewDateEnd = moment().add(1, 'days').format('YYYY-MM-DD')

class PresensiGuru extends Component {
	constructor() {
		super();
		this.state = {
			dataPresensi	: [],
			namaSiswa		: "",
			content_id		: 0,
			pageCount		: 0,
			currentPage		: 0,
			dateNowStart	: NewDateStart,
			dateNowEnd		: NewDateEnd,
			dateStart 		: moment(),
			dateEnd 		: moment(),
			isLoading		: false,
			isModalShow		: false
		};

		this.toggleModal = this.toggleModal.bind(this);
		this.handleChangeDatepickerStart = this.handleChangeDatepickerStart.bind(this);
		this.handleChangeDatepickerEnd = this.handleChangeDatepickerEnd.bind(this);
		this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this);
		this.exportFile = this.exportFile.bind(this);
	}

	toggleModal() {
		this.setState({ isModalShow: !this.state.isModalShow });
	}

	handleSubmitDeleteButton() {
		Alert.error("BELUM ADA APINYA");

		this.toggleModal();
	}

	handlePageClick(data) {
		let selected = data.selected; // zero based index

		this.setState({ currentPage: selected }, () => {
			this.loadData();
		});
	}

	exportFile() {
		let presensi = [["Nama Lengkap", "Kelas", "Tanggal Presensi", "Waktu", "Tipe", "Status"]]
		this.state.dataPresensi.map(item => {
		  presensi.push([item.user_nama,
						item.kelas_nama,
						item.presensi_create_date, 
						item.presensi_create_time, 
						item.presensi_tipe,
						item.presensi_status
					])
		})
		const wb = XLSX.utils.book_new()
		const wsAll = XLSX.utils.aoa_to_sheet(presensi)
			XLSX.utils.book_append_sheet(wb, wsAll, "All Users")
			XLSX.writeFile(wb, "Rekap Presensi Per Siswa-"+ moment().format('DD-MMMM-YYYY') +".xlsx")
	  }

	loadData() {
		this.setState({ isLoading: true });
		

		const params = qs.stringify({
			page: this.state.currentPage + 1,
			type_date: "",
			start:this.state.dateNowStart,
			end:this.state.dateNowEnd,
			guru_id:this.props.match.params.user_id,
			status:"all"
		});

		axios({
            method: 'post',
            url: '/attendanceguru/data?' + params
        })
			.then(response => {
				const result = response.data;
				console.log(result);
				if (result.status === true) {
					this.setState({
						dataPresensi: result.data.presensis.data,
						namaSiswa: result.data.presensis.data.user_nama,
						pageCount: result.data.presensis.last_page,
						isLoading: false
					});
				} else {
					Alert.error(result.text);
					this.setState({ isLoading: false });
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoading: false });
				Alert.error("Gagal terhubung ke server!");
			});
	}

	componentDidMount() {
		this.loadData();
	}

	handleChangeDatepickerStart(e) {
        this.setState({
            dateStart:e,
            dateNowStart:e.format('YYYY-MM-DD'),
            isLoading:true
        },()=>{
                this.loadData()
            })
	}
	handleChangeDatepickerEnd(e) {
        this.setState({
            dateEnd:e,
            dateNowEnd:e.add(1,'days').format('YYYY-MM-DD'),
            isLoading:true
        },()=>{
                this.loadData()
            })
    }

	render() {
		console.log(this.props.match)
		return (
			<div className="col-sm-12">
				<div className="card">
					<div className="card-header">Presensi</div>
						<div className="form-group row" style={{ margin: "15px 5px 15px 15px" }}>
							<div className="col-md-12">
								<label className="form-control-label">
									<b>Range Tanggal Export Presensi</b>
								</label>
							</div>
							<div className="col-md-2">
								<DatePicker
									selected={this.state.dateStart}
									onChange={this.handleChangeDatepickerStart}
									showYearDropdown
									scrollableYearDropdown
									yearDropdownItemNumber={15}
								/>
							</div>
							{('-')}
							<div className="col-md-2">
								<DatePicker
									selected={this.state.dateEnd}
									onChange={this.handleChangeDatepickerEnd}
									showYearDropdown
									scrollableYearDropdown
									yearDropdownItemNumber={15}
								/>
							</div>
							<div className="col-sm-3">
							<button
								className="btn btn-primary"
								onClick={this.exportFile}>Export Presensi
							</button>
						</div>
					</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : this.state.dataPresensi.length === 0 ? (
							"Belum ada presensi..."
						) : (
							<div>
								<table className="table table-striped table-bordered animated fadeIn">
									<thead>
										<tr>
											<th width="100px">Foto</th>
											<th>Nama Siswa</th>
											<th>Tipe</th>
											<th>Keterangan</th>
											<th>Status</th>
											<th width="30">Opsi</th>
										</tr>
									</thead>
									<tbody>
										{this.state.dataPresensi.map(item => {
											return (
												<tr key={item.presensi_id}>
													<td>
														<img
															src={
																item.presensi_foto !== ""
																	? FOTO_PRESENSI_HOST+item.presensi_foto
																	: "./noimage.gif"
															}
															alt=""
															className="img-thumbnail"
															style={{ width: "100px" }}
														/>
													</td>
													<td>{item.user_nama}</td>
													<td>{item.presensi_tipe}</td>
													<td>
														{item.presensi_create_date
														+" - "+
														item.presensi_create_time}
														</td>
													<td>
														{item.presensi_status}
													</td>
													<td>
														<NavLink
															to={`${this.props.match.url}/detail/${
																item.presensi_id
															}`}
															className="btn btn-secondary btn-sm"
														>
															Detail
														</NavLink>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>

								<Paging
									handlePageClick={this.handlePageClick.bind(this)}
									pageCount={this.state.pageCount}
									currentPage={this.state.currentPage}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default PresensiGuru;



// WEBPACK FOOTER //
// ./src/views/Users/PresensiGuru.js